import { PLATFORM } from '@configs/platform.config'

type ExistingAbhaSuccessCopyData = {
  title?: string
  mobileTitle?: string
  viewCtaText?: string
  downloadCtaText?: string
  mobileViewCtaText?: string
  mobileDownloadCtaText?: string
}

type ExistingAbhaSuccessCopyFallbacks = {
  TITLE: string
  MOBILE_LINKED_CARDS_TITLE: string
  VIEW_CTA_TEXT: string
  DOWNLOAD_CTA_TEXT: string
  MOBILE_VIEW_CTA_TEXT: string
  MOBILE_DOWNLOAD_CTA_TEXT: string
}

type ExistingAbhaSuccessCopyInput = {
  data?: ExistingAbhaSuccessCopyData
  fallbackData: ExistingAbhaSuccessCopyFallbacks
}

type ExistingAbhaSuccessCopyConfig = {
  title: (input: ExistingAbhaSuccessCopyInput) => string
  viewCtaText: (input: ExistingAbhaSuccessCopyInput) => string
  downloadCtaText: (input: ExistingAbhaSuccessCopyInput) => string
}

export const ABHA_EXISTING_ABHA_SUCCESS_COPY_CONFIG: Record<string, ExistingAbhaSuccessCopyConfig> = {
  [PLATFORM.DESKTOP]: {
    title: ({ data, fallbackData }) => data?.title ?? fallbackData.TITLE,
    viewCtaText: ({ data, fallbackData }) => data?.viewCtaText ?? fallbackData.VIEW_CTA_TEXT,
    downloadCtaText: ({ data, fallbackData }) => data?.downloadCtaText ?? fallbackData.DOWNLOAD_CTA_TEXT,
  },
  [PLATFORM.MOBILE]: {
    title: ({ data, fallbackData }) => data?.mobileTitle ?? fallbackData.MOBILE_LINKED_CARDS_TITLE,
    viewCtaText: ({ data, fallbackData }) =>
      data?.mobileViewCtaText ?? data?.viewCtaText ?? fallbackData.MOBILE_VIEW_CTA_TEXT,
    downloadCtaText: ({ data, fallbackData }) =>
      data?.mobileDownloadCtaText ?? data?.downloadCtaText ?? fallbackData.MOBILE_DOWNLOAD_CTA_TEXT,
  },
}
